/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pc_Faq_8_QInputs */

const en_pc_faq_8_q = /** @type {(inputs: Pc_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Is this the official PhotoCraft website?`)
};

const zh_pc_faq_8_q = /** @type {(inputs: Pc_Faq_8_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`这是 PhotoCraft 官方网站吗？`)
};

/**
* | output |
* | --- |
* | "Is this the official PhotoCraft website?" |
*
* @param {Pc_Faq_8_QInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const pc_faq_8_q = /** @type {((inputs?: Pc_Faq_8_QInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pc_Faq_8_QInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_pc_faq_8_q(inputs)
	return zh_pc_faq_8_q(inputs)
});
export { pc_faq_8_q as "pc.faq.8.q" }